import React, { useEffect, useState } from 'react';
import { IPaginated } from 'src/types/paginated';
import qs from "qs";
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import PaginationComponet from '../GlobalComponents/PaginationComponet';
import { CircularProgress } from '@mui/material';
import { truncateString } from 'src/helpers/helperFunctions';
import IsFavoriteComponent from '../Customer/ProductsAndServicesComponents/IsFavoriteComponent';
import biomarkerIcon from 'src/assets/images/biomarker-ye.png';
import { Link } from 'react-router-dom';
import AddCartComponent from '../Customer/ProductsAndServicesComponents/AddCartComponent';
import wishlistIcon from 'src/assets/images/no-wishlist-icon.png'
import { CURRENCY } from 'src/lib/constans';

interface IObj {
    _id: string;
    name: string;
    description: string;
    image: string;
    regularPrice: number;
    salePrice: number;
    isLiked: boolean;
    prescriptionRequired: boolean;
    noOfTests: number;
};
interface IResponse {
    documents: IObj[];
    paginated: IPaginated;
};

const FavPackages: React.FC = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj[]>([]);
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    });
    const [queryParams, setQueryParams] = useState<{ page: number; limit: number; bool: boolean; }>({
        page: 1,
        limit: 10,
        bool: false,
    });
    const handleRemove = (obj: { productId: string; }) => {
        if (data?.length > 1) {
            setData(prev => prev?.filter(v => v._id !== obj?.productId));
        } else {
            setQueryParams(prev => ({
                ...prev,
                bool: !prev.bool,
                page: prev?.page > 1 ? prev?.page - 1 : prev?.page
            }));
        }
    };

    const fetch = async () => {
        setIsLoader(true);
        const { bool, ...actulaParams } = queryParams;
        const { res, err } = await httpRequest<IResponse>({ path: `/diagnostic-package/fav?${qs.stringify(actulaParams)}` });
        if (res) {
            const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } = res;
            setData(documents);
            setPaginated(paginated);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, [queryParams]);
    return (
        <div className="my-list-dashbaord-main">
            {isLoader ?
                <div className='flex justify-center mt-6'>
                    <CircularProgress style={{ width: 24, height: 24, color: "#00443f" }} />
                </div>
                : data?.length ?
                    data?.map(item => (
                        <div key={item?._id} className="my-list-dashbaord">
                            <div className='my-list-dashbaord-left'>
                                <img src={`${item?.image}`} alt="" />
                            </div>
                            <div className='customer-pharmacy-card-content-text'>
                                <div className='flex items-start justify-between'>
                                    <div>
                                        <Link to={`/customer/diagnostic-product-detail/package/${item?._id}/view`} className='font-Poppins-SemiBold mb-1 font-size-18px text-[#4F6367] block underline'>{truncateString(item?.name || "", 70)}</Link>
                                        <p className='font-Poppins-Medium w-[90%] font-size-16px text-[#707070]'>{truncateString(item?.description || "", 100)}</p>
                                    </div>
                                    <IsFavoriteComponent
                                        category="package"
                                        onSuccess={handleRemove}
                                        productId={item?._id}
                                        isFav={item?.isLiked || false}
                                    />
                                </div>

                                <div>
                                    <div className='my-list-data-price mt-0 mb-2'>
                                        <strong className='font-size-20px font-Poppins-Bold theme-color-green'>{CURRENCY} {item?.salePrice || item?.regularPrice}</strong>
                                        {item?.salePrice != null && item?.salePrice > 0 && (
                                            <strong className='font-size-13px line-through font-Poppins-Regular text-[#878787]'>{CURRENCY} {`${item?.regularPrice || "-"}`}</strong>
                                        )}
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className='flex justify-between'>
                                            <div className="flex gap-2 items-center">
                                                <img src={biomarkerIcon} alt="" className="max-w-[28px]" />
                                                <span className='text[#707070] font-size-14px font-Poppins-Regular'>{`${item?.noOfTests || ""} Tests`}</span>
                                            </div>
                                        </div>
                                        <AddCartComponent
                                            textBtn={true}
                                            productId={item?._id}
                                            type="diagnostic"
                                            prescriptionRequired={item?.prescriptionRequired || false}
                                            quantity={1}
                                            itemType="package"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    <div className='parchi-icon-order'>
                        <img src={wishlistIcon} alt="" />
                        <span className="text-center font-Poppins-Medium font-size-22px">No Packages in the list</span>
                    </div>
            }

            {paginated?.totalPages > 1 &&
                <PaginationComponet
                    total={paginated.totalPages}
                    currentPage={paginated.currentPage}
                    setCurrentPage={(_page) => setQueryParams(prev => ({ ...prev, page: _page }))}
                />
            }
        </div>
    );
};

export default FavPackages;